module.exports = __webpack_public_path__ + "static/img/home_09.a99df8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_09.jpg
// module id = wNTV
// module chunks = 1